import React, { useEffect } from 'react';
import { MuiThemeProvider } from "@material-ui/core/styles";
import useStyles, { getMuiTheme } from "./styles";

import { useTheme, Tooltip, TextField } from '@material-ui/core';
import { useSelector } from 'react-redux';


export default function Integer({ field, onChange, errors = {}, value, small = false, variant = "outlined", readOnly,disabled }) {
  const classes = useStyles();

  const currentTheme = useTheme();

  let iserror = errors[field.name] ? true : false;

  const { editViewTabData } = useSelector((state) => state.edit);
  const module = Object.keys(editViewTabData)[0];
  // useEffect(() => {
  //   if (field.name === 'total_amount' && (module === 'AOS_Quotes' || module === 'AOS_Inovices')) {
  //     onChange(value)
  //   }
  // }, [value])
  return (
    <MuiThemeProvider theme={getMuiTheme(currentTheme)}>

      <Tooltip
        title={field.comment || ''}
        disableHoverListener={field.comment ? false : true}
        placement="top-start"
        disableFocusListener={field.comment ? false : true}
        disableTouchListener={field.comment ? false : true}
      >
        <TextField
          type={module === 'AOS_Quotes' || 'AOS_Invoices' && field.type === 'decimal' ? 'text' : "number"}
          // type="text"
          id={field.name}
          error={iserror}
          required={field.required === 'true' ? true : false}
          name={field.name}
          variant={variant}
          size={small ? "small" : "medium"}
          label={field.label}
          onChange={(e) => onChange(e.target.value)}
          value={value}
          // placeholder={field.label}
          className={classes.decimalInput}
          helperText={errors[field.name] ? errors[field.name] : null}
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            readOnly: readOnly,

          }}
          disabled={disabled}
        />
      </Tooltip>
    </MuiThemeProvider>
  );
}
